import { Stack } from '@fluentui/react';
import { Context } from '@micro-frontend-react/employee-experience/lib/Context';
import { IEmployeeExperienceContext } from '@micro-frontend-react/employee-experience/lib/IEmployeeExperienceContext';
import { RouteComponentProvider } from '@micro-frontend-react/employee-experience/lib/RouteComponentProvider';
import * as React from 'react';
import { Switch, Route } from 'react-router-dom';
import { IHostAppState } from './Redux';
import { PageNotFound404 } from './Pages/PageNotFound404/PageNotFound404';

export function Routes(): React.ReactElement {

  const { useSelector } = React.useContext(Context as React.Context<IEmployeeExperienceContext>);
  const pages = useSelector((state: IHostAppState) => state.PagesReducer);
  const pathname = window.location.pathname;
  return (
    <Stack className={'Container'}>
      <Switch>
        <RouteComponentProvider
          path="/"
          config={{
            script: '/bundles/Home.js',
            name: 'Home',
          }}
          exact
        />
         <RouteComponentProvider
          path="/Security"
          config={{
            script: __LOAD_PAGE_URLS__.__SAT_SECURITY_LOAD_PAGE_URL__,
            name: 'Security',
          }}
          exact
        />
        <RouteComponentProvider
          path="/"
          config={{
            script: __LOAD_PAGE_URLS__.__PACKET_DEFAULT_LOAD_PAGE_URL__ ,
            name: 'PacketGeneration',
          }}
          exact
        />
        <RouteComponentProvider
          path="/"
          config={{
            script: __LOAD_PAGE_URLS__.__SAT_REPORTS_DEFAULT_LOAD_PAGE_URL__,
            name: 'JobEliminationTrackingSummary',
          }}
          exact
        />
          {pages.pages.map((page, index) => {
            if (page) {
              return (
                <RouteComponentProvider
                  key={page.key || `page-${index}`}
                  path={page.route}
                  config={{
                    script: page.url,
                    name: page.name,
                  }}
                  exact
                />
              )
            }
            return null;
          })}
        <Route path="*" component={PageNotFound404} />
      </Switch>
    </Stack>
  );
}